if (!Number.prototype.round) {
    Number.prototype.round = function (decimals) {
        decimals = decimals || 0
        return Number(Math.round(this + 'e' + decimals) + 'e-' + decimals)
    }
}

if (!Number.prototype.between) {
    Number.prototype.between = function (low, high, inclusive) {
        if (low === null) {
            throw 'no low value provided for between'
        }
        if (high === null) {
            throw 'no high value provided for between'
        }
        if (inclusive) {
            return this <= high && this >= low
        }
        return this < high && this > low
    }
}

if (!Number.prototype.incBetween) {
    Number.prototype.incBetween = function (low, high) {
        return this.between(low, high, true)
    }
}

if (!Number.prototype.formatCurrency) {
    Number.prototype.formatCurrency = function (rounding) {
        rounding = rounding == null ? 2 : rounding
        return this.toFixed(rounding).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }
}

if (!Number.prototype.zeroPad) {
    Number.prototype.zeroPad = function (width) {
        var str = this + ''
        return str.length >= width ? str : new Array(width - str.length + 1).join('0') + str
    }
}

if (!Number.prototype.getLength) {
    Number.prototype.getLength = function () {
        return this.toString().length
    }
}

if (!Number.prototype.abbreviate) {
    const suffixes = ['', 'k', 'M', 'B', 'T', 'Q', 'P', 'S']
    Number.prototype.abbreviate = function (significantDigits) {
        significantDigits = significantDigits === undefined ? 3 : significantDigits
        var scientificParts = this.toExponential(significantDigits - 1).split('e+') // exponent of ten
        var digits = scientificParts[0]
        var exponent = scientificParts[1]
        var suffixIndex = Math.floor(exponent / 3)
        var suffix = suffixes[suffixIndex]
        var moveDecimalRight = exponent % 3
        var value = digits * Math.pow(10, moveDecimalRight)

        // The round here alleviates certain numbers ending up with miniscule decimals eg: (13.600000000000000001)
        return `${value.round(3)}${suffix}`
    }
}

if (!Number.prototype.asByteSize) {
    Number.prototype.asByteSize = function () {
        if (this > 1099511627776) {
            return 'A LOT of Bytes'
        }

        if (this > 1099511627776) {
            return (this / 1073741824).round(2) + 'TB'
        }

        if (this > 1073741824) {
            return (this / 1073741824).round(2) + 'GB'
        }

        if (this > 1048576) {
            return (this / 1048576).round(2) + 'MB'
        }

        if (this > 1024) {
            return (this / 1024).round(0) + 'KB'
        }

        return this.round(0) + 'B'
    }
}

if (!Number.prototype.gigabytes) {
    Number.prototype.gigabytes = function () {
        return this * 1073741824
    }
}

if (!Number.prototype.megabytes) {
    Number.prototype.megabytes = function () {
        return this * 1048576
    }
}

if (!Number.prototype.kilobytes) {
    Number.prototype.kilobytes = function () {
        return this * 1024
    }
}

if (!Number.prototype.padStart) {
    Number.prototype.padStart = function (length, pad) {
        return this.toString().padStart(length, pad.toString())
    }
}
